module.exports = __webpack_public_path__ + "static/media/[Performance]2010-07-18-2.ed5f0346.md";